import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ShieldCheck, ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // If already authenticated (e.g. user hit the back button), never show the
  // login form again — send them straight to the dashboard, replacing history.
  useEffect(() => {
    if (!loading && user) navigate("/admin/dashboard", { replace: true });
  }, [loading, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6">
        <Link to="/" className="mb-8 flex items-center gap-1 text-sm font-semibold text-white/70">
          <ChevronLeft size={16} /> Back to event
        </Link>
        <div className="grid h-14 w-14 place-items-center rounded-2xl bg-secondary text-white">
          <ShieldCheck size={26} />
        </div>
        <h1 className="mt-5 font-display text-3xl font-extrabold text-white">Staff Login</h1>
        <p className="mt-1 text-sm text-white/60">Bluegrass Mustang Makeover · Admin</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-white/70">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 h-12 w-full rounded-xl border border-white/20 bg-white/10 px-4 text-white outline-none placeholder:text-white/40 focus:ring-2 focus:ring-secondary"
              placeholder="admin@bluegrassmustang.com" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-white/70">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 h-12 w-full rounded-xl border border-white/20 bg-white/10 px-4 text-white outline-none placeholder:text-white/40 focus:ring-2 focus:ring-secondary"
              placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="rounded-lg bg-red-500/20 px-3 py-2 text-sm text-red-200">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={busy}
            className="h-12 w-full rounded-full bg-secondary font-bold text-white transition-transform active:scale-95 disabled:opacity-60">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
